import type { RouteConfig } from 'vue-router/types/router';
import admin from './admin';
import libraries from './libraries';
import account from './account';

const routes: RouteConfig[] = [
    ...admin,
    ...libraries,
    ...account,
    {
        path: '/home',
        name: 'Templates',
        component: () => import(/* webpackChunkName: "templates" */ '@/views/Templates/Main.vue')
    },
    {
        path: '/designs',
        name: 'UserDesigns',
        component: () => import(/* webpackChunkName: "designs" */ '@/views/UserDesigns/UserDesigns.vue')
    },
    {
        path: '/myProductBases',
        name: 'UserProductBases',
        component: () => import(/* webpackChunkName: "designs" */ '@/views/MyProductBases/MyProductBasesView.vue')
    }
];

export default routes;
